/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameThreadRequest
 */
export interface RenameThreadRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameThreadRequest
     */
    title: string;
}

/**
 * Check if a given object implements the RenameThreadRequest interface.
 */
export function instanceOfRenameThreadRequest(value: object): value is RenameThreadRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function RenameThreadRequestFromJSON(json: any): RenameThreadRequest {
    return RenameThreadRequestFromJSONTyped(json, false);
}

export function RenameThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
    };
}

export function RenameThreadRequestToJSON(json: any): RenameThreadRequest {
    return RenameThreadRequestToJSONTyped(json, false);
}

export function RenameThreadRequestToJSONTyped(value?: RenameThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
    };
}

